// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:where(.vuetify-styles) .v-main {
  flex: 1 0 auto;
  max-width: 100%;
  transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  padding-left: var(--v-layout-left);
  padding-right: var(--v-layout-right);
  padding-top: var(--v-layout-top);
  padding-bottom: var(--v-layout-bottom);
}
@media (prefers-reduced-motion: reduce) {
  :where(.vuetify-styles) .v-main {
    transition: none;
  }
}
:where(.vuetify-styles) .v-main__scroller {
  max-width: 100%;
  position: relative;
}
:where(.vuetify-styles) .v-main--scrollable {
  display: flex;
}
:where(.vuetify-styles) .v-main--scrollable {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
:where(.vuetify-styles) .v-main--scrollable > .v-main__scroller {
  flex: 1 1 auto;
  overflow-y: auto;
  --v-layout-left: 0px;
  --v-layout-right: 0px;
  --v-layout-top: 0px;
  --v-layout-bottom: 0px;
}`, "",{"version":3,"sources":["webpack://./node_modules/vuetify/lib/components/VMain/VMain.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,eAAe;EACf,6CAA6C;EAC7C,kCAAkC;EAClC,oCAAoC;EACpC,gCAAgC;EAChC,sCAAsC;AACxC;AACA;EACE;IACE,gBAAgB;EAClB;AACF;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;AACxB","sourcesContent":[".v-main {\n  flex: 1 0 auto;\n  max-width: 100%;\n  transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  padding-left: var(--v-layout-left);\n  padding-right: var(--v-layout-right);\n  padding-top: var(--v-layout-top);\n  padding-bottom: var(--v-layout-bottom);\n}\n@media (prefers-reduced-motion: reduce) {\n  .v-main {\n    transition: none;\n  }\n}\n.v-main__scroller {\n  max-width: 100%;\n  position: relative;\n}\n.v-main--scrollable {\n  display: flex;\n}\n.v-main--scrollable {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n.v-main--scrollable > .v-main__scroller {\n  flex: 1 1 auto;\n  overflow-y: auto;\n  --v-layout-left: 0px;\n  --v-layout-right: 0px;\n  --v-layout-top: 0px;\n  --v-layout-bottom: 0px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
